export default __webpack_public_path__ + "static/media/Data-Scientist.6ae5891a.png";